<template lang="pug">
div(v-bind:class="{ content: isRoute, post: isRoute }",v-if="post")
    h2.post-title
        span(@click="navigateTo(post.id)",style="cursor: pointer;") {{post.title}}
        span(v-if="isUserLoggedIn") &nbsp;
            a.button.is-white.icon(@click="editPost(post.id)",
              v-if="post.markdown",title="Edit Post")
                span.fas.fa-edit
            a.button.is-white.icon(@click="deletePost(post.id)",
              title="Delete Post(NO CONFIRMATION)")
                span.fas.fa-trash-alt
    p.label.is-small {{new Date(post.created_at).toLocaleDateString()}}
    div.post-description(v-html="post.html")

</template>

<script>
import postService from "@/services/postsService";
import authService from "@/services/authService";

export default {
  name: "Post",
  props: ["postProp"],
  data() {
    return {
      loadedPost: null,
      isRoute: false,
      isUserLoggedIn: false,
    };
  },
  computed: {
    post() {
      return this.postProp ? this.postProp : this.loadedPost;
    }
  },
  methods: {
    navigateTo(id) {
      if (this.$router.path !== "/post") {
        this.$router.push({ name: "post", params: { id } });
      }
    },
    editPost(id) {
      this.$router.push({ name: "edit post", params: { id } });
    },
    deletePost(id) {
      postService.deletePost(id);
    }
  },
  created() {
    this.isRoute = this.$route.path.indexOf("/post") > -1;
    if (this.isRoute) {
      postService.$on("getPost", post => {
        this.loadedPost = post;
      });

      postService.getPost(this.$route.params.id);
    }
    authService.$on("authChange", user => {
      this.userIsLoggedIn = !!user;
    });
    this.isUserLoggedIn = !!authService.user;
  }
};
</script>
